import { render, staticRenderFns } from "./case.vue?vue&type=template&id=2ca0ff93&scoped=true&"
import script from "./case.vue?vue&type=script&lang=ts&"
export * from "./case.vue?vue&type=script&lang=ts&"
import style0 from "./case.vue?vue&type=style&index=0&id=2ca0ff93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0ff93",
  null
  
)

export default component.exports